import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class DeleteMatningsInformationStyrningCommand extends BasicCommand<DeleteMatningsInformationStyrningCommand> {
    get primaryKey(): IPrimaryKey<DeleteMatningsInformationStyrningCommand> {
        return {
            guid: this.guid
        };
    }
    guid: string;
    static readonly $groupKey = "MatningsInformationStyrning";
    static readonly $type = "DeleteMatningsInformationStyrningCommand";
    constructor(init: (instance: DeleteMatningsInformationStyrningCommand) => void) {
        super(DeleteMatningsInformationStyrningCommand.$type, DeleteMatningsInformationStyrningCommand.$groupKey, CommandType.Delete);
        init(this);
    }
}
